module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Dinner-fb3e5de7d3c16d7dfec604ed411495b9.svg";